import { observable, action, flow, computed, toJS } from 'mobx';
import Stores from 'config/Stores';
console.log('Stores', Stores);
import Serv from './PersonalServ';
import { Toast } from 'antd-mobile';
import Config from 'config/Config';
import Util from 'utils';
import { cloneDeep, isEmpty } from 'lodash';
import { FileTypeMap } from 'utils/constants';

const defaultListData = {
  data: [],
  isLoading: false,
  pageNum: 1,
  pages: 1
};
class PersonalMod {
  // 用户信息
  @observable userInfo = {};
  // 可开卡类型：0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
  @observable canCardType = -1;

  // 是否是权益共享卡用户
  @observable isSupplementaryCard = 0;

  // 新消息数量
  @observable msgCount = 0;

  // 优惠券数量
  @observable totalCoupon = 0;

  // 待付款数量、待收货数量、待发货数量
  @observable payOrderCount = 0;

  @observable outOrderCount = 0;

  @observable putOrderCount = 0;

  @observable userInfoCardData = {};

  // @observable groupList = [];

  // 生日信息
  @observable birthdayInfo = {};
  @observable posterList = [];
  // 生日弹窗集合
  @observable birthdayArr = [];

  // 弹框index
  @observable modalIndex = 0;
  // 实体卡号、密码、电话
  @observable cardCode = Stores.AppMod.userType == 2 ? Stores.AppMod.userInfo.cardCode : '';

  //判断店铺和会员是否有合利共盈活动权限
  @observable isProfitSharingAuth = {
    memberAuthority: 0, //会员权限(0无，1有)	integer($int32)
    shopAuthority: 0 //店铺权限(0无，1有) false	integer($int32)
  };

  @observable canUpgradeClick = true;

  @observable showShouldSupply = 0;

  @observable sharePosterNoList = [];
  @observable isShareCardPosterNo = false;

  @observable canUpgrade = true;
  // 头等舱详情
  @observable firstClassInfo = {};

  @observable questDetail = null;

  @observable recommendListData = defaultListData;
  @observable myFrequentlyList = []; // 我的常用原始信息

  @observable donateTotal = 0; // 捐款总额

  @observable showBatchOrder = 0; // 是否显示肽素乳畅享卡

  fastPreviewViewableItems = []; //快速预览商品

  @observable certificationStatus = 0;

  @observable storeInfo = null;

  @observable hasPurview = false; // 是否有实体店认证的入口

  /**
   * 更改状态
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  setRecommendListArray = () => {
    this.recommendListData = defaultListData;
  };

  @action
  changeVideoToImage = () => {
    console.log('changeVideoToImage');
    const list = cloneDeep(toJS(this.recommendListData.data));
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
      if (!item.inView) {
        item.isFirstClick = true;
      }
    });
    this.recommendListData.data = list;
  };

  @action
  changePaused = (paused, item) => {
    const list = cloneDeep(toJS(this.recommendListData.data));
    const currentItem = list.find((listItem) => listItem.id === item.id) || {};
    if (isEmpty(currentItem)) return;
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
    });
    // 将列表里内其他正在播放的视频暂停
    if (!paused) {
      const playIndex = list.findIndex((product) => {
        const mediaRespDtoList = product.mediaRespDtoList || [];
        const hasVideo = mediaRespDtoList.some((media) => media.fileType == FileTypeMap.VIDEO);
        return product.paused === false && hasVideo;
      });
      if (playIndex > -1) {
        const pausedItem = list[playIndex];
        pausedItem.paused = true;
        pausedItem.isFirstClick = !pausedItem.inView;
      }
    }
    currentItem.paused = paused;
    currentItem.isFirstClick = !currentItem.inView;
    this.recommendListData.data = list;
  };

  /**
   * 获取用户信息
   */
  getUserInfo = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getUserInfo();
      if (`${resultCode}` === '0' && data) {
        this.userInfo = data;
      }
    } catch (error) {}
  });

  @computed
  get belongShopEditaled() {
    const { userType } = Stores.AppMod;
    // 202109，修改“所属店铺”的展示规则
    // 1、会员自购，个人收货或自提（可以修改订单归属成任意店铺）
    // 2、会员代客下单，个人收货或自提（可以修改订单归属成任意店铺）
    let isShow = false;
    // 会员自购
    if (userType == 2) {
      isShow = true;
    }
    // 控制是否显示
    if (!isShow) {
      return false;
    }
    return true;
    // 仅个人收货 或 自提，才显示
    // if ([1, 2].includes(+this.deliveryType)) {
    //   return true;
    // }
    return false;
  }

  /**
   * 当前主卡用户是否绑定了权益共享卡用户
   */
  getEquityBindRelationByMaster = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getEquityBindRelationByMaster();
      if (resultCode == 0) {
        return data || 0;
      }
    } catch (error) {
      return 0;
    }
  });

  /**
   * 当前用户是否权益共享卡用户
   */
  getEquityBindRelationByUserId = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getEquityBindRelationByUserId();
      if (resultCode == 0) {
        this.isSupplementaryCard = data || 0;
      }
    } catch (error) {
      this.isSupplementaryCard = 0;
    }
  });

  /**
   * 订单数角标查询
   */
  getOrderCount = flow(function* () {
    try {
      const { data } = yield Serv.getOrderCount();
      this.payOrderCount = data.initOrderNum;
      this.outOrderCount = data.waitDeliveryOrderNum;
      this.putOrderCount = data.deliveryOrderNum;
    } catch (error) {}
  });

  // 获取拼团订单
  // getMyGroupOrderOrderList = flow(function* () {
  //   try {
  //     let params = {
  //       pageNum: 1,
  //       pageSize: 10,
  //       status: '',
  //       userId: Stores.AppMod.userInfo.id
  //     };
  //     const { data } = yield Serv.getMyGroupOrderOrderList(params);
  //     this.groupList = data.list || [];
  //     console.log('getMyGroupOrderOrderList', data);
  //   } catch (error) {
  //     console.log('getMyGroupOrderOrderList err', error);
  //   }
  // });

  /**
   * 获取可以分享的海报列表
   */
  getPosterNo = flow(function* (posterNo) {
    try {
      const { data } = yield Serv.getPosterNo(posterNo);
      console.log('data', data);
      let list = data.pictures.split(',');
      let newlist = [];
      for (let i = 0; i < list.length; i++) {
        newlist.push({
          imgUrl: list[i]
        });
      }
      this.posterList = newlist;
      // this.payOrderCount = data.initOrderNum;
      // this.outOrderCount = data.waitDeliveryOrderNum;
      // this.putOrderCount = data.deliveryOrderNum;
    } catch (error) {}
  });
  /**
   * 是否可以根据海报编号查询分享的选择卡号列表(销售顾问)
   */
  getSupportQueryShareCardCodesByPosterNo = flow(function* (posterNo) {
    try {
      const { data } = yield Serv.getSupportQueryShareCardCodesByPosterNo(posterNo);

      this.isShareCardPosterNo = data;
      return data;
      // this.payOrderCount = data.initOrderNum;
      // this.outOrderCount = data.waitDeliveryOrderNum;
      // this.putOrderCount = data.deliveryOrderNum;
    } catch (error) {}
  });
  /**
   * 根据海报编号查询分享的选择卡号列表(销售顾问)
   */
  getShareCardCodesByPosterNo = flow(function* (posterNo) {
    try {
      const { data } = yield Serv.getShareCardCodesByPosterNo(posterNo);

      if (data) {
        this.sharePosterNoList = data || [];
      }
      return data || [];
      // this.payOrderCount = data.initOrderNum;
      // this.outOrderCount = data.waitDeliveryOrderNum;
      // this.putOrderCount = data.deliveryOrderNum;
    } catch (error) {}
  });

  /**
   * 极萃二维码
   */
  generateQRCode = flow(function* () {
    try {
      const { data } = yield Serv.generateQRCode({ cardCode: Stores.AppMod.userInfo.cardCode });

      if (data) {
        return data.url || '';
      }
      return '';
    } catch (error) {
      return '';
    }
  });

  /**
   * 消息数角标查询
   * @param {String} type - 订单类型
   */
  getMsgCount = flow(function* (type = 'INIT') {
    try {
      const { data } = yield Serv.getMsgCount();
      this.msgCount = +data.actNoReadcount + +data.orderNoReadcount + +data.sysNoReadcount;
    } catch (error) {}
  });
  /**
   * 新站点
   *
   */
  getUserCardLevel = flow(function* () {
    try {
      const { data } = yield Serv.getUserCardLevel();
      this.userInfoCardData = data;
    } catch (error) {}
  });

  // /**
  //  * 获取各种优惠券数量
  //  */
  // getCouponCount = flow(function*() {
  //   const { data } = yield Serv.getCouponCount({ userId: Stores.AppMod.userInfo.id });
  //   this.totalCoupon = 0;
  //   data.forEach(item => {
  //     this.totalCoupon += item.count;
  //   });
  // });

  /**
   * 查询是否可开实体卡或虚拟卡
   * @param {String} consultant - 健康顾问编号
   */
  queryCanApplyType = flow(function* (consultant) {
    try {
      const params = {
        channel: 0,
        healthConsultantCardCode: consultant || '8888888888'
      };
      const { data } = yield Serv.queryCanApplyType(params);
      return data;
    } catch (error) {
      return null;
    }
  });

  /**
   * 自主升级-查询是否可以升级
   */
  queryCanUpgrade = flow(function* (sign) {
    try {
      const { data } = yield Serv.queryCanUpgrade(sign);
      this.canUpgrade = true;
      return true;
    } catch (error) {
      this.canUpgrade = false;
      return false;
    }
  });

  /**
   * 查询是否会员信息不全
   */
  checkMsgIsFull = flow(function* () {
    try {
      const { data } = yield Serv.checkMsgIsFull(Stores.AppMod.userInfo.cardCode);
      return data;
    } catch (error) {
      return null;
    }
  });

  /**
   * 自主升级 - 查询卡类型
   */
  queryCardType = flow(function* (exObj) {
    const { cardCode = '' } = Stores.AppMod.userInfo || {};
    const { inletTitle = '', sourceTag = '' } = exObj || {};
    try {
      const params = {
        bizUpgradeCardReqDto: {
          cardCode,
          channel: 1
        }
      };
      const { data } = yield Serv.queryCardType(params);
      Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
      window.app.routerGoTo({
        pathname: '/register/memGiftbag',
        clear: true,
        state: {
          applyType: '4',
          HealthyCardCode: cardCode,
          inletTitle,
          sourceTag
        }
      });
      return data;
    } catch (error) {}
  });

  //合利共盈权限
  isShopAuthority = flow(function* (params) {
    try {
      const res = yield Serv.isShopAuthority();
      console.log(res, 'isShopAuthorityisShopAuthorityisShopAuthority');
      if (res.resultCode == '0') {
        this.isProfitSharingAuth = res.data;
      } else {
        Toast.fail(res.resultMsg, 1);
      }
    } catch (error) {}
  });

  /**
   * 弹出安全提示窗
   * 1、没有修改默认密码 2、未完成身份证明照片上传
   * 满足上述任一条件，就会进行弹窗提示
   */
  checkSafeTips = flow(function* () {
    // 如果已经检查过了，下次页面就不需要判断
    const { isCheckSafeTipsFlag } = Stores.AppMod;
    console.log('PersonalMod - isCheckSafeTipsFlag = ' + isCheckSafeTipsFlag);
    if (isCheckSafeTipsFlag) {
      return false;
    }

    // 改变标识，代表已经判断过一次
    Stores.AppMod.isCheckSafeTipsFlag = true;

    // cardAttribute 0虚拟卡、1实体卡
    // cardPwdStatus 是否修改密码状态 1.默认未修改  2 已经修改
    const { cardPwdStatus } = Stores.AppMod.userInfo || {};

    if (cardPwdStatus == 1) {
      console.log('PersonalMod - cardPwdStatus = 1 and show safe tips');

      // 未修改默认密码，弹窗提示
      return true;
    } else if (cardPwdStatus == 2) {
      console.log('PersonalMod - cardPwdStatus = 2 and check certificates');

      // 检查是否未上传身份证明的照片
      const res = yield this.loadAndCheckCertificate();
      return res;
    }
  });

  /**
   * 检查是否未上传身份证明的照片
   */
  loadAndCheckCertificate = flow(function* () {
    // 没收到接口数据时，默认不弹提示
    let isShowTips = false;

    // 查询用户的证件信息，判断身份证明一栏，是否有上传照片
    try {
      const { data } = yield Serv.queryCertificateList();

      if (data) {
        // 改变标识
        isShowTips = true;

        // 遍历数组，查看身份证明的obj，是否有上传照片
        // 只要其中一种身份证明，有上传照片，就可以不用弹窗提示
        data.map((item) => {
          // 1身份证、2护照、3港澳通行证、4其他
          const { certificateType, certificateContent } = item;

          // 身份证
          if (certificateType == 1) {
            const { positiveUrl, reverseSideUrl } = certificateContent || {};
            if (!!positiveUrl && !!reverseSideUrl) {
              isShowTips = false;
            }
          }

          // 护照、港澳通行证、其他
          if ([2, 3, 4].includes(certificateType)) {
            const { certificateUrl } = certificateContent || {};
            if (!!certificateUrl && certificateUrl.length > 0) {
              isShowTips = false;
            }
          }
        });
      }

      console.log('PersonalMod - loadAndCheckCertificate isShowTips = ' + isShowTips);
      return isShowTips;
    } catch (error) {
      console.log('PersonalMod - loadAndCheckCertificate error', error);
      return false;
    }
  });

  /**
   * 获取生日信息
   */
  fetchBirthdayInfo = flow(function* () {
    try {
      const { data } = yield Serv.fetchBirthdayInfo();
      // 取第一个弹框
      let initObj = {};
      if (Array.isArray(data)) {
        this.birthdayArr = data.filter((f) => f.imgUrlSecond);
        initObj = this.birthdayArr[0];
      }
      if (initObj) {
        this.birthdayInfo = initObj;
      }
    } catch (error) {}
  });
  getUserShouldSupply = flow(function* () {
    try {
      const { data } = yield Serv.getUserShouldSupply();
      this.showShouldSupply = data;
      return data;
      // if (data && data.birthDayTag === 1) {
      //   this.birthdayInfo = data;
      // }
    } catch (error) {}
  });

  verifyMemberCardValid = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.verifyMemberCardValid();
      if (data) {
        return data;
      } else {
        return false;
      }
    } catch (error) {}
  });

  queryVerifyUpgrade = flow(function* (cardCode) {
    try {
      const data = yield Serv.queryVerifyUpgrade(cardCode);
      return data;
    } catch (error) {
      return error;
    }
  });

  queryStoreAuditDetail = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.queryStoreAuditDetail();
      if (data) {
        return data;
      } else {
        return false;
      }
    } catch (error) {}
  });

  /**
   * 获取店铺类型列表
   */
  getStoreTypeList = flow(function* (isPartner = false) {
    try {
      const { healthConsultantNum } = Stores.AppMod.userInfo || {};
      const params = {
        configure: 1,
        healthCode: healthConsultantNum,
        jointCreationTag: isPartner ? 1 : 0
      };
      let { data } = yield Serv.getStoreTypeList(params);
      if (Array.isArray(data)) {
        data = data.map((item) => {
          // storeName 0 对外名称 1 开店政策
          const { storeName, typeName, externalName } = item;
          return {
            ...item,
            typeName: storeName === 0 ? externalName : typeName
          };
        });
        return data;
      }
      return [];
    } catch (error) {
      console.log('dshjkhdakj===>', error);
      return [];
    }
  });

  /**
   * 获取区域配置情况
   *
   * @memberof PersonalMod
   */
  getRegionConfiguration = flow(function* (typeId) {
    try {
      const { data } = yield Serv.getRegionConfiguration({ typeId });
      if (data) {
        return data;
      }
      return false;
    } catch (error) {
      return false;
    }
  });
  /**
   * 查询头等舱详情
   */
  queryFirstClassInfo = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.queryFirstClassInfo();

      if (resultCode === '0') {
        this.firstClassInfo = data;
      }
    } catch (error) {}
  });

  // 获取我的常用
  getMyUsual = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getMyUsual();
      if (resultCode == 0) {
        this.myFrequentlyList = data || [];
      } else {
        this.myFrequentlyList = [];
      }
    } catch (err) {
      console.log(err);
      this.myFrequentlyList = [];
    }
  });

  // 获取我的常用
  setMyUsual = flow(function* (params) {
    try {
      yield Serv.setMyUsual(params);
    } catch (err) {
      console.log(err);
    }
  });

  // 问卷小调查
  getShowQuest = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getShowQuest();
      if (resultCode === '0') {
        this.questDetail = data;
      }
    } catch (error) {
      return error;
    }
  });

  // 获取产品列表
  getRecommendProductList = flow(function* (loadMore) {
    this.recommendListData.isLoading = true;
    let pageNum = 1;
    if (!loadMore) {
      this.recommendListData.data = [];
    } else {
      pageNum = this.recommendListData.pageNum + 1;
    }

    const params = {
      // 前端类目id集合
      frontDirIdList: [],
      // 品牌id集合
      brandIdList: [],
      // 角标id集合
      cornerIdList: [],
      // 用于区分显示的文案是类目还是搜索内容
      keyword: '',
      // 排序方式 1:时间 2:销量 3:价格 4:综合(默认)
      sortType: 4,
      // 排序升降序：ASC:升序；DESC：降序
      sortOrder: 'DESC',
      // 是否有库存
      inStock: 1,
      // 产品id列表
      itemIdList: [],
      itemProperties: '',
      distributionRatio: ''
    };

    try {
      const { data = {} } = yield Serv.getRecommendProductList({ pageSize: 10, pageNum }, params);
      this.recommendListData.isLoading = false;
      data.list = data.list.map((item) => {
        return {
          ...item,
          paused: item.paused === undefined ? true : item.paused,
          isFirstClick: item.isFirstClick === undefined ? true : item.isFirstClick
        };
      });
      if (params.pageNum !== 1) {
        const arr = this.recommendListData.data || [];
        this.recommendListData.data = arr.concat(data.list || []);
      } else {
        this.recommendListData.data = data.list || [];
      }
      // 重置页数等信息
      this.recommendListData.pageNum = data.pageNum;
      this.recommendListData.pages = data.pages;
    } catch (error) {}
  });

  // 用户公益信息查询
  getUserDonateInfo = flow(function* () {
    try {
      const { data } = yield Serv.getUserDonateInfo();
      console.log('data', data);
      if (data) {
        this.donateTotal = data.donateTotal;
      }
    } catch (err) {
      return {};
    }
  });

  // 获取是否显示肽素乳畅享卡
  getShowBatchOrder = flow(function* () {
    try {
      const { data } = yield Serv.getShowBatchOrder();
      this.showBatchOrder = data;
    } catch (err) {
      return {};
    }
  });

  // 云连锁
  getDetailByUserIdAndType = flow(function* (params) {
    try {
      const { data } = yield Serv.getDetailByUserIdAndType(params);
      return data || {};
    } catch (err) {
      return {};
    }
  });

  getStoreInfo = flow(function* () {
    try {
      const status = yield Stores.AppMod.queryCertificationStatus();
      const { data } = yield Serv.getStoreInfo();
      this.certificationStatus = status;
      this.storeInfo = data;
    } catch (err) {
      this.storeInfo = null;
      console.log('getStoreInfo err', err);
    }
  });

  getIndividualPurview = flow(function* () {
    try {
      const { data } = yield Serv.getIndividualPurview();
      this.hasPurview = data;
    } catch (err) {
      this.hasPurview = false;
      console.log('getStoreInfo err', err);
    }
  });
}

const personalMod = new PersonalMod();
export default personalMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/PersonalMod.js